import IncomeSplitAllMonths from '../../../banking/components/income-split/overview/IncomeSplitAllMonths';

export default function IncomeSplitAllMonthsScreen() {
    return <IncomeSplitAllMonths />;
}
